import { useContext } from "react";
import Panel from "../Panel";
import classnames from "classnames";
import { Label, Message } from "semantic-ui-react";
import { themeContext } from "../../containers/ThemeProvider";

export const ON_NET_TEXT = "On-net";
export const OFF_NET_TEXT = "Off-net";

const SUPPLIER_COLOURS = {
  Vodafone: { label: 'red',    hex: '#e60000' },
  Zen:      { label: 'teal',   hex: '#008788' },
  Giganet:  { label: 'green',  hex: '#21ba45' },
};

export default function ZenBroadbandGroup({
  broadbandGroup,
  selectedProduct,
  selectProduct,
  lineDetails,
}) {
  const { products, broadbandType, onNet, provider } = broadbandGroup;
  const networkType = onNet ? ON_NET_TEXT : OFF_NET_TEXT;
  const { assets } = useContext(themeContext);
  const supplierColour = SUPPLIER_COLOURS[provider] ?? { label: 'grey', hex: '#767676' };

  let message = "";

  switch (broadbandType.toUpperCase()) {
    case "FTTC":
      message = lineDetails?.fttc?.availabilityDescription || lineDetails?.fttc?.ragDescription;
      break;
    case "SOGEA":
      message = lineDetails?.sogea?.availabilityDescription || lineDetails?.sogea?.ragDescription;
      break;
    case "COPPER":
      message =
        lineDetails?.adsl2Plus?.availabilityDescription ||
        lineDetails?.adsl2Plus?.ragDescription ||
        lineDetails?.adsl2PlusAnnexM?.availabilityDescription ||
        lineDetails?.adsl2PlusAnnexM?.ragDescription;
      break;
    case "GFAST":
      message = lineDetails?.gFast?.availabilityDescription || lineDetails?.gFast?.ragDescription;
      break;
    case "FTTP":
      message = lineDetails?.fttp?.availabilityDescription || lineDetails?.fttp?.ragDescription;
      break;
    case "FTTP SYMMETRICAL":
      message = lineDetails?.FttpSymmetrical?.availabilityDescription || lineDetails?.FttpSymmetrical?.ragDescription;
      break;
    default:
      message = "";
  }

  const panelHeader = (
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ fontWeight: 'bold' }}>{broadbandType}</span>
      <Label size="small" color={supplierColour.label}>{provider}</Label>
      <Label size="small" color={onNet ? 'green' : 'grey'}>{networkType}</Label>
    </span>
  );

  return (
    <div className="supplier-section" style={{ borderLeftColor: supplierColour.hex }}>
      {message && <Message info header={message} />}
      <Panel header={panelHeader} className="zen-broadband-group">
        <div
          className="products-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          {products.map((product) => (
            <div
              key={product.productCode}
              onClick={() => selectProduct({ ...product, provider })}
              className={classnames("product", {
                selected: selectedProduct?.productCode === product.productCode,
              })}
              style={{
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "calc(33.33% - 12px)",
                minHeight: "120px",
                boxSizing: "border-box",
                cursor: "pointer",
                overflow: "hidden",
              }}
            >
              {/* Thin supplier-coloured stripe at the top of every card */}
              <div style={{ height: "4px", backgroundColor: supplierColour.hex }} />

              <div style={{ padding: "10px 12px" }}>
                <p
                  className="product__title"
                  style={{
                    fontSize: "1.05em",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    color: assets?.headerColour,
                    marginBottom: "8px",
                    lineHeight: "1.3",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {product.productName}
                </p>

                <div
                  className="product__info"
                  style={{
                    fontSize: "0.8em",
                    fontWeight: "bold",
                    lineHeight: "1.4",
                  }}
                >
                  {product?.marketLocation?.toLowerCase() !== "unavailable" && (
                    <p>Market Location: {product.marketLocation}</p>
                  )}
                  <p>{networkType} {broadbandType} is available</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
